import localizations from '../localizations';
import {
  CustomerFacingCancellationReason,
  CustomerLocalization,
  ErrorLocalization,
  FAQLocalization,
  FactBoxLocalization,
  GiftcardLocalization,
  LocalizationCategory,
  LookupLocalization,
  MembershipLocalization,
  MetaLocalization,
  PriceLocalization,
  ProductLocalization,
  RecipientLocalization,
  SaunaLocalization,
} from '../localizations/types';
import useLocale from './use-locale';

const useTypeSafeLocalize = () => {
  const { languageAsEnum } = useLocale();

  // typescript overloads
  function localize(
    category: LocalizationCategory.customer,
    localization: CustomerLocalization
  ): string;
  function localize(
    category: LocalizationCategory.error,
    localization: ErrorLocalization
  ): string;
  function localize(
    category: LocalizationCategory.faq,
    localization: FAQLocalization
  ): string;
  function localize(
    category: LocalizationCategory.factBox,
    localization: FactBoxLocalization
  ): string;
  function localize(
    category: LocalizationCategory.lookup,
    localization: LookupLocalization
  ): string;
  function localize(
    category: LocalizationCategory.membership,
    localization: MembershipLocalization
  ): string;
  function localize(
    category: LocalizationCategory.meta,
    localization: MetaLocalization
  ): string;
  function localize(
    category: LocalizationCategory.price,
    localization: PriceLocalization
  ): string;
  function localize(
    category: LocalizationCategory.product,
    localization: ProductLocalization
  ): string;
  function localize(
    category: LocalizationCategory.recipient,
    localization: RecipientLocalization
  ): string;
  function localize(
    category: LocalizationCategory.sauna,
    localization: SaunaLocalization
  ): string;
  function localize(
    category: LocalizationCategory.giftcard,
    localization: GiftcardLocalization
  ): string;
  function localize(
    category: LocalizationCategory.cancellationReason,
    localization: CustomerFacingCancellationReason
  ): string;

  function localize(
    category: LocalizationCategory,
    localization: string | CustomerFacingCancellationReason
  ) {
    const localizedCateogry = localizations[languageAsEnum][category];
    return localizedCateogry[localization as keyof typeof localizedCateogry];
  }

  return localize;
};

export default useTypeSafeLocalize;
